import { render, staticRenderFns } from "./ProductFamilyList.vue?vue&type=template&id=2ce4d7f5&scoped=true&"
import script from "./ProductFamilyList.vue?vue&type=script&lang=js&"
export * from "./ProductFamilyList.vue?vue&type=script&lang=js&"
import style0 from "./ProductFamilyList.vue?vue&type=style&index=0&id=2ce4d7f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce4d7f5",
  null
  
)

export default component.exports